// src/components/Hero.jsx
import React from 'react';
import CTAButton from './CTAButton';

const Hero = () => {

    // For section links that scroll to sections
    const handleSectionClick = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section className="hero">
            <div className="container">
                <div className="hero-content">
                    <h1 className="hero-title">Luxury Auto Detailing — Right At Your Doorstep.</h1>
                    <p className="hero-subtitle">
                        Your Car, Immaculate. Your Time, Respected.
                    </p>
                    <div className="hero-cta">
                        <CTAButton text="View Services" onClick={() => handleSectionClick('services')}/>
                    </div>
                </div>
            </div>
            <div className="hero-overlay"></div>
        </section>
    );
};

export default Hero;